export default __webpack_public_path__ + "static/media/gameplayBgMb2.b574d127.png";